import { BILL_TYPES, FREQUENCY_CAPABLE_TYPES } from "../constants/billTypes";

// Shared by the landlord upload screen and the tenant bill-view screen so
// both agree on "what's actually due this cycle" for a given flat.
//
// `flatDetail` is the property record with the Phase-2 charge shape:
//   flatDetail.maintenance = { amount, frequency: "monthly" | "annual", dueMonth: 1-12 }
//   (same shape for .water, .security, .trash)
// Properties registered before this feature existed won't have these keys —
// PropertyFormModal's edit-flow normalizer backfills `frequency: "monthly"`
// for them, but this function also defends against completely missing data
// by treating an absent/zero-amount charge as "never show".
export function getDueBillTypesForThisCycle(flatDetail, referenceDate = new Date()) {
  const always = [BILL_TYPES.RENT, BILL_TYPES.ELECTRICITY, BILL_TYPES.GAS];

  if (!flatDetail) return always;

  const currentMonth = referenceDate.getMonth() + 1; // 1-12

  const conditional = FREQUENCY_CAPABLE_TYPES.filter((type) => {
    const charge = flatDetail[type];
    if (!charge || !Number(charge.amount)) return false;
    if ((charge.frequency || "monthly") === "monthly") return true;
    return Number(charge.dueMonth) === currentMonth;
  });

  // Water, security and trash are one "Fixed Charges" bill, so any of them
  // being due means that single bill is due.
  const FIXED_PARTS = [BILL_TYPES.WATER, BILL_TYPES.SECURITY, BILL_TYPES.TRASH];
  const separate = conditional.filter((type) => !FIXED_PARTS.includes(type));
  const hasFixed = conditional.some((type) => FIXED_PARTS.includes(type));

  return [...always, ...separate, ...(hasFixed ? [BILL_TYPES.FIXED] : [])];
}
